import { Link } from "react-router-dom";

export default function InfoSections() {
  return (
    <>
      {/* What Is Mulebuy Spreadsheet */}
      <section className="py-14 md:py-20 bg-background-100">
        <div className="container-site">
          <div className="max-w-3xl mx-auto text-center">
            <span className="inline-block text-accent-600 text-sm font-medium tracking-wider uppercase">/ About</span>
            <h2 className="mt-3 text-3xl md:text-4xl font-heading font-bold text-foreground-950">
              What Is Mulebuy Spreadsheet?
            </h2>
            <p className="mt-6 text-foreground-600 text-sm md:text-base leading-relaxed">
              The <strong>Mulebuy Spreadsheet</strong> is one of the easiest ways to discover trusted products, verified sellers, and high-quality finds. Our team continuously updates the latest <strong>Mulebuy Spreadsheet</strong> with new products, quality check information, shipping guides, and buying tutorials. Whether you are searching for sneakers, clothing, bags, or accessories, the updated <strong>Mulebuy Spreadsheet</strong> helps buyers save time and avoid unreliable sellers.
            </p>
            <p className="mt-4 text-foreground-600 text-sm md:text-base leading-relaxed">
              Instead of browsing hundreds of unverified stores and scattered forum threads, the <strong>Mulebuy Spreadsheet</strong> consolidates everything into one organized resource. Each entry includes direct links, seller reliability indicators, and quality check references so you can make informed decisions quickly. For anyone serious about finding the <strong>best Mulebuy Spreadsheet</strong> experience, this tool eliminates guesswork and streamlines the entire discovery process.
            </p>
          </div>
        </div>
      </section>

      {/* Why Use + Stats */}
      <section className="py-14 md:py-20 bg-background-50">
        <div className="container-site">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">
                Why Thousands of Buyers Use Mulebuy Spreadsheet
              </h2>
              <p className="mt-5 text-foreground-600 text-sm md:text-base leading-relaxed">
                Thousands of buyers rely on the <strong>Mulebuy Spreadsheet</strong> because it simplifies the entire purchasing process. Instead of searching through hundreds of stores, buyers can access curated products, seller ratings, QC images, and buying recommendations in one place.
              </p>
              <ul className="mt-6 space-y-3">
                {[
                  "Verified sellers with proven track records",
                  "Direct product links to save browsing time",
                  "QC reference images for quality assurance",
                  "Shipping recommendations per region",
                  "Daily updated finds and new listings",
                  "Safer purchasing decisions with buyer tips",
                ].map((item) => (
                  <li key={item} className="flex items-start gap-3 text-sm text-foreground-700">
                    <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-checkbox-circle-fill text-accent-500 text-base"></i>
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <div className="bg-white border border-background-200 rounded-2xl p-8 md:p-10">
                <div className="grid grid-cols-2 gap-6">
                  {[
                    { value: "50,000+", label: "Products Indexed" },
                    { value: "2,000+", label: "Trusted Sellers" },
                    { value: "Daily", label: "Spreadsheet Updates" },
                    { value: "100+", label: "QC Guides" },
                  ].map((stat) => (
                    <div key={stat.label} className="text-center">
                      <div className="text-2xl md:text-3xl font-bold text-accent-600 font-heading">
                        {stat.value}
                      </div>
                      <div className="mt-1 text-xs md:text-sm text-foreground-500">
                        {stat.label}
                      </div>
                    </div>
                  ))}
                </div>
                <div className="mt-8 pt-6 border-t border-background-200 text-center">
                  <p className="text-sm text-foreground-600">
                    <strong className="text-foreground-900">Worldwide Buyers</strong> trust the updated Mulebuy Spreadsheet
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Comparison Table */}
      <section className="py-14 md:py-20 bg-background-100">
        <div className="container-site">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 text-center">
              Mulebuy Spreadsheet vs Traditional Search
            </h2>
            <p className="mt-3 text-foreground-500 text-sm text-center">
              See why the updated Mulebuy Spreadsheet saves time and improves buying decisions
            </p>

            <div className="mt-10 overflow-x-auto">
              <table className="w-full border-collapse">
                <thead>
                  <tr className="border-b-2 border-background-300">
                    <th className="text-left py-4 px-4 text-sm font-semibold text-foreground-800">Feature</th>
                    <th className="text-center py-4 px-4 text-sm font-semibold text-accent-600">
                      <span className="inline-flex items-center gap-1">
                        <i className="ri-star-fill w-3.5 h-3.5 flex items-center justify-center"></i>
                        Mulebuy Spreadsheet
                      </span>
                    </th>
                    <th className="text-center py-4 px-4 text-sm font-semibold text-foreground-500">Traditional Search</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    { feature: "Verified Sellers", mulebuy: true, traditional: false },
                    { feature: "QC References", mulebuy: true, traditional: "Limited" },
                    { feature: "Product Categories", mulebuy: "Extensive", traditional: "Scattered" },
                    { feature: "Buying Guides", mulebuy: true, traditional: false },
                    { feature: "Shipping Information", mulebuy: true, traditional: "Limited" },
                    { feature: "Time Saving", mulebuy: "High", traditional: "Low" },
                    { feature: "Daily Updates", mulebuy: true, traditional: false },
                    { feature: "Seller Ratings", mulebuy: true, traditional: "Rare" },
                  ].map((row, i) => (
                    <tr key={row.feature} className={`border-b border-background-200 ${i % 2 === 0 ? "bg-white/50" : "bg-white"}`}>
                      <td className="py-3.5 px-4 text-sm text-foreground-700 font-medium">{row.feature}</td>
                      <td className="py-3.5 px-4 text-center text-sm">
                        {typeof row.mulebuy === "boolean" ? (
                          row.mulebuy ? (
                            <span className="w-5 h-5 flex items-center justify-center mx-auto">
                              <i className="ri-check-line text-accent-500 text-lg"></i>
                            </span>
                          ) : (
                            <span className="w-5 h-5 flex items-center justify-center mx-auto">
                              <i className="ri-close-line text-foreground-300 text-lg"></i>
                            </span>
                          )
                        ) : (
                          <span className="text-accent-600 font-semibold">{row.mulebuy}</span>
                        )}
                      </td>
                      <td className="py-3.5 px-4 text-center text-sm">
                        {typeof row.traditional === "boolean" ? (
                          row.traditional ? (
                            <span className="w-5 h-5 flex items-center justify-center mx-auto">
                              <i className="ri-check-line text-foreground-400 text-lg"></i>
                            </span>
                          ) : (
                            <span className="w-5 h-5 flex items-center justify-center mx-auto">
                              <i className="ri-close-line text-foreground-300 text-lg"></i>
                            </span>
                          )
                        ) : (
                          <span className="text-foreground-500">{row.traditional}</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      {/* Trusted Sellers + QC Safety */}
      <section className="py-14 md:py-20 bg-background-50">
        <div className="container-site">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
            <div>
              <h3 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                Trusted Mulebuy Sellers
              </h3>
              <p className="mt-4 text-foreground-600 text-sm md:text-base leading-relaxed">
                Finding <strong>Mulebuy sellers</strong> you can trust is essential for a smooth buying experience. Our editorial team evaluates seller history, customer feedback, product consistency, and shipping reliability before listing them in the <strong>Mulebuy Spreadsheet</strong>. We regularly audit our seller recommendations to ensure the information stays current.
              </p>
              <p className="mt-3 text-foreground-600 text-sm md:text-base leading-relaxed">
                The <strong>best Mulebuy Spreadsheet</strong> includes detailed seller profiles with ratings, response times, and verified transaction histories. This transparency helps both beginners and experienced buyers find reliable partners for their purchases.
              </p>
            </div>

            <div>
              <h3 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                Is Mulebuy Safe?
              </h3>
              <p className="mt-4 text-foreground-600 text-sm md:text-base leading-relaxed">
                Safety is a top priority for anyone using the platform. Our <strong>Mulebuy QC guide</strong> and spreadsheet recommendations help users navigate potential risks effectively. The <strong>Mulebuy Spreadsheet</strong> includes seller verification checks, QC photo references, and practical safety tips that reduce common purchasing pitfalls.
              </p>
              <div className="mt-5 flex flex-wrap gap-2">
                {["Seller Verification", "Product QC Checks", "Shipping Advice", "Scam Prevention", "Payment Safety", "Buying Tutorials"].map((item) => (
                  <span key={item} className="whitespace-nowrap inline-flex items-center gap-1.5 bg-accent-50 text-accent-800 text-xs font-medium px-3 py-1.5 rounded-full">
                    <i className="ri-shield-check-line w-3 h-3 flex items-center justify-center"></i>
                    {item}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Latest Updates + Trending */}
      <section className="py-14 md:py-20 bg-background-100">
        <div className="container-site">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
            <div>
              <h3 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                Latest Spreadsheet Updates
              </h3>
              <p className="mt-2 text-accent-600 text-sm font-medium">Updated June 2026</p>
              <ul className="mt-5 space-y-3">
                {[
                  "New sneaker finds added across top categories",
                  "Fresh seller recommendations with updated ratings",
                  "Shipping information revised for 2026 routes",
                  "Latest QC guides available with new photo references",
                  "Additional product categories expanded",
                ].map((item) => (
                  <li key={item} className="flex items-start gap-3 text-sm text-foreground-700">
                    <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-arrow-right-circle-line text-accent-500"></i>
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                Trending Searches
              </h3>
              <div className="mt-5 flex flex-wrap gap-2">
                {[
                  "Best Mulebuy Spreadsheet",
                  "Updated Mulebuy Spreadsheet",
                  "Mulebuy Finds",
                  "Mulebuy Sellers",
                  "Is Mulebuy Safe",
                  "Mulebuy QC Guide",
                  "Mulebuy Shipping Guide",
                  "Mulebuy Spreadsheet 2026",
                ].map((term) => (
                  <span key={term} className="whitespace-nowrap cursor-default bg-white border border-background-200 text-foreground-700 text-xs px-3 py-2 rounded-full hover:border-accent-300 hover:text-accent-700 transition-colors duration-200">
                    {term}
                  </span>
                ))}
              </div>

              <div className="mt-8 p-5 bg-accent-50 border border-accent-200 rounded-xl">
                <h4 className="font-heading text-lg font-semibold text-foreground-900">Our Research Process</h4>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                  Our editorial team analyzes product quality, seller reputation, quality check images, user feedback, shipping experiences, and buying guides. Information is updated regularly to maintain accuracy and relevance for all <strong>Mulebuy Spreadsheet</strong> users.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Article Link CTA */}
      <section className="py-10 md:py-14 bg-background-50">
        <div className="container-site">
          <div className="bg-gradient-to-r from-accent-50 via-accent-100/80 to-accent-50 border border-accent-200 rounded-2xl p-8 md:p-10 text-center">
            <h3 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              Want to Learn More About Mulebuy Spreadsheet?
            </h3>
            <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              Read our in-depth buying guide covering everything from setup to advanced tips for the updated Mulebuy Spreadsheet 2026.
            </p>
            <Link
              to="/mulebuy-spreadsheet-guide"
              className="whitespace-nowrap cursor-pointer mt-5 inline-flex items-center gap-2 bg-primary-500 text-white px-6 py-3 rounded-full font-semibold text-sm hover:bg-primary-600 transition-colors duration-200"
            >
              Read Complete Guide
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}